import { render } from "./WindowsTaskBarItem.vue?vue&type=template&id=747e2dfa&scoped=true"
import script from "./WindowsTaskBarItem.vue?vue&type=script&lang=js"
export * from "./WindowsTaskBarItem.vue?vue&type=script&lang=js"

import "./WindowsTaskBarItem.vue?vue&type=style&index=0&id=747e2dfa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-747e2dfa"

export default script